import { IState } from '../../store';
import { IBookingDetail } from '../../types/newbuildingBooking';

export const selectBookingDetails = (state: IState): IBookingDetail[] | null => {
  const { profitbaseBooking } = state.offerData;

  if (!profitbaseBooking || !profitbaseBooking.bookingTerms) {
    return null;
  }

  const { bookingTerms } = profitbaseBooking;
  const details: IBookingDetail[] = [];

  if (bookingTerms.duration) {
    details.push({ label: 'Срок', text: bookingTerms.duration });
  }

  if (bookingTerms.price) {
    details.push({ label: 'Стоимость', text: bookingTerms.price });
  }

  return details.length ? details : null;
};
